module.exports = __webpack_public_path__ + "img/chart-scatter-bubble.84ffe257.svg";